module.exports = __webpack_public_path__ + "static/media/book.500a573a.svg";